import {
    REQUESTS_BY_STATUS,
    REQUESTS_BY_TYPE,
    EXPORT_REQUESTS_BY_STATUS,
    EXPORT_REQUESTS_BY_TYPE,
    UNIFIED_REPORT
} from "../types";

const initialState = {
    reportData: [] as any,
    reportDataCount: 0,
    assigneeEmployee: [] as any,
    exportedRequestByStatus:[] as any ,
    exportedRequestByType:[] as any
};
const report = (state = initialState, action : any) => {
    switch (action.type) {
       
        case REQUESTS_BY_STATUS:
            return {
                ...state,
                reportData: action.requestsByStatus
            };

        case REQUESTS_BY_TYPE:
            return {
                ...state,
                reportData: action.requestsByType
            };

        case UNIFIED_REPORT:
            return {
                ...state,
                reportData: action.reportData,
                reportDataCount: action.totalRequests
            };
            case EXPORT_REQUESTS_BY_STATUS:
            return {
                ...state,
                exportedRequestByStatus: action.exportedRequestByStatus
            };
            case EXPORT_REQUESTS_BY_TYPE:
            return {
                ...state,
                exportedRequestByType: action.exportedRequestByType
            };

        default:
            return state;
    }
};

export default report;



